import React, { useState, useEffect } from "react";

export const SuppressedPatternsList: React.FC = () => {
  const [patterns, setPatterns] = useState<string[]>([]);

  useEffect(() => {
    const loadPatterns = () => {
      const stored = localStorage.getItem("debugSuppressedPatterns");
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          setPatterns(parsed);
        } catch (e) {
          console.error("Failed to load suppressed patterns:", e);
        }
      }
    };

    loadPatterns();

    // Listen for storage changes
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === "debugSuppressedPatterns") {
        loadPatterns();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    // Also listen for custom storage events (same-tab updates)
    const handleCustomStorage = () => loadPatterns();
    window.addEventListener(
      "debugSuppressedPatternsChanged" as any,
      handleCustomStorage,
    );

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener(
        "debugSuppressedPatternsChanged" as any,
        handleCustomStorage,
      );
    };
  }, []);

  const removePattern = (pattern: string) => {
    const newPatterns = patterns.filter((p) => p !== pattern);
    localStorage.setItem(
      "debugSuppressedPatterns",
      JSON.stringify(newPatterns),
    );
    setPatterns(newPatterns);

    // Dispatch custom event for same-tab updates
    window.dispatchEvent(new CustomEvent("debugSuppressedPatternsChanged"));
  };

  const clearAll = () => {
    localStorage.setItem("debugSuppressedPatterns", JSON.stringify([]));
    setPatterns([]);

    // Dispatch custom event for same-tab updates
    window.dispatchEvent(new CustomEvent("debugSuppressedPatternsChanged"));
  };

  if (patterns.length === 0) {
    return (
      <div style={{ opacity: 0.5, fontStyle: "italic", fontSize: "12px" }}>
        No suppressed patterns. Right-click log messages to add suppressions.
      </div>
    );
  }

  return (
    <div>
      <div
        style={{
          marginBottom: "8px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ fontSize: "11px", opacity: 0.7 }}>
          {patterns.length} suppressed pattern{patterns.length !== 1 ? "s" : ""}
        </span>
        <button
          onClick={clearAll}
          style={{
            padding: "2px 8px",
            fontSize: "10px",
            background: "rgba(255,107,107,0.2)",
            border: "1px solid rgba(255,107,107,0.3)",
            borderRadius: "3px",
            color: "#ff6b6b",
            cursor: "pointer",
          }}
        >
          Clear All
        </button>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {patterns.map((pattern) => (
          <div
            key={pattern}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "4px 8px",
              background: "rgba(255,255,255,0.03)",
              borderRadius: "3px",
              fontSize: "11px",
              fontFamily: "monospace",
            }}
          >
            <span style={{ flex: 1, wordBreak: "break-all" }}>{pattern}</span>
            <button
              onClick={() => removePattern(pattern)}
              style={{
                padding: "2px 6px",
                marginLeft: "8px",
                fontSize: "9px",
                background: "rgba(255,255,255,0.1)",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: "3px",
                cursor: "pointer",
                color: "var(--text-secondary)",
              }}
              title="Remove suppression"
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
